import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'reactstrap';
import { TranslationsKeys } from '../../../../../locales/translations';

export function BadgeStatus({ active }: { active: boolean }) {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_WARNINGS_STUDENT_HISTORY,
  );

  const status = active ? 'active' : 'inactive';

  const texts = useMemo(() => {
    return {
      active: t('badgeStatus.active'),
      inactive: t('badgeStatus.inactive'),
    };
  }, [t]);

  const colors = useMemo(() => {
    return {
      active: '#CEF0DA',
      inactive: '#DDEFFF',
    };
  }, []);

  const statusText = useMemo(() => {
    return {
      active: texts.active,
      inactive: texts.inactive,
    };
  }, [texts]);

  return (
    <Badge
      className="status-badge fs-16 fw-400 py-2 px-4 text-dark ml-3"
      style={{ backgroundColor: colors[status] }}
      pill
    >
      {statusText[status]}
    </Badge>
  );
}
